import { useCallback, useEffect, useState } from "react";
import { listTemplateCategories } from "../services/campaigns-service";

const SHOPIFY_CATEGORY_KEY = "shopify";

export const useShopifyCreateGate = (accountId) => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!accountId) {
      return;
    }
    if (typeof listTemplateCategories !== "function") {
      return;
    }
    setIsLoading(true);
    const response = await listTemplateCategories();
    setIsLoading(false);
    if (!response || response?.error) {
      setIsEnabled(false);
      return;
    }
    const categories = Array.isArray(response?.categories) ? response.categories : [];
    const shopifyCategory = categories.find(
      (item) => String(item?.key || "").toLowerCase() === SHOPIFY_CATEGORY_KEY
    );
    setIsEnabled(Boolean(shopifyCategory?.enabled));
  }, [accountId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { isEnabled, isLoading, refresh };
};
